import * as React from 'react';

function SvgThumbFilled(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.992 14.196c0 .717-.23 1.337-.687 1.862.125.367.187.683.186.95a2.593 2.593 0 01-.537 1.712 2.57 2.57 0 010 1.461 2.43 2.43 0 01-.675 1.175c.075.933-.129 1.687-.612 2.261-.533.633-1.353.958-2.462.975h-1.611c-.55 0-1.15-.065-1.8-.194-.649-.129-1.155-.25-1.517-.362a69.165 69.165 0 01-1.506-.494c-1.025-.358-1.683-.541-1.974-.55a.826.826 0 01-.562-.243.748.748 0 01-.238-.556v-8.01c0-.208.075-.389.225-.543a.82.82 0 01.537-.256c.2-.017.517-.262.95-.737.433-.475.854-.98 1.262-1.512.567-.725.987-1.225 1.262-1.5.15-.15.279-.35.387-.6.109-.25.182-.451.22-.605.037-.154.093-.406.168-.756.058-.325.11-.58.156-.762.046-.184.127-.4.244-.65.116-.25.258-.458.425-.625a.769.769 0 01.562-.237c.383 0 .727.044 1.031.131.304.087.554.196.75.325.196.129.362.297.5.506.137.208.237.396.3.562.062.167.112.375.15.625.037.25.058.437.062.562.004.125.006.288.006.487 0 .317-.039.634-.118.95a5.12 5.12 0 01-.237.75 10.365 10.365 0 01-.47.924c-.057.1-.104.192-.136.275a3.146 3.146 0 00-.1.3h3.46c.65 0 1.212.237 1.687.712.474.475.712 1.038.712 1.687zm-15.594-.8H5.8a.768.768 0 00-.563.238.769.769 0 00-.237.562v7.997c0 .217.08.404.237.563a.77.77 0 00.563.237h3.598a.77.77 0 00.562-.237.77.77 0 00.238-.563v-7.997a.769.769 0 00-.238-.562.768.768 0 00-.562-.237zm-1.437 7.766a.779.779 0 01-.562.231.772.772 0 01-.568-.23.773.773 0 01-.232-.57c0-.216.077-.403.232-.561a.762.762 0 01.568-.238c.217 0 .404.08.562.238a.768.768 0 01.238.562.762.762 0 01-.238.568z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgThumbFilled;
